import { useOneOffPageDetail } from '@fs/zion-rootstech'
import useErrorHandlerOverlay from './useErrorHandlerOverlay'
import { useBrightspotImageSizes } from '../providers/BrightspotConfigProvider'
import useDetailAugmentation from './useDetailAugmentation'

export default function useOneOffPageData({ path }) {
  // web-derived, bandwidth-aware image sizes injected into the shared hook
  const imageSizes = useBrightspotImageSizes()
  const { loading, data, error } = useOneOffPageDetail(path, { imageSizes })
  useErrorHandlerOverlay(error)

  const { data: augmentedData, loading: augmentedLoading } = useDetailAugmentation({
    loading,
    data,
  })

  return { loading: augmentedLoading, data: augmentedData, error }
}
